import { actionIsForFamilyProduct } from '../utils/utils';
import { mixin, reduceOneObjectInArray } from '../../../core/js/utils/reducerUtils';

import { productSubReducer } from './productSubReducer';
import { productFavoritesSubReducer } from './productFavoritesReducer';
import { carouselSubReducer } from './carouselSubReducer';
import { shopTheLookSubReducer } from './shopTheLookSubReducer';
import { registrySubReducer } from './registrySubReducer';
import { isQuickshop } from '../utils/quickshopUtils';
import { getProductSubReducers } from './subReducerOverride';

const commonSubReducers = [
    productSubReducer,
    productFavoritesSubReducer,
    carouselSubReducer,
    shopTheLookSubReducer,
    registrySubReducer
];

export function reduceProductActions(state = {}, action) {
    const subReducerSet = getProductSubReducers(commonSubReducers);
    for (let i = 0; i < subReducerSet.length; i++) {
        const subReducer = subReducerSet[i];
        const newState = subReducer(state, action);

        // if state has passed through and not been reduce,
        // pass off to the next reducer
        if (newState !== state) {
            return newState;
        }
    }

    return state;
}

export function reduceFamilyProductActions(state = {}, action) {
    const familyProductIndex = action.meta.component.multipleIndex;
    const targetedProduct = state.familyProducts[familyProductIndex];
    const subReducerSet = getProductSubReducers(commonSubReducers);

    for (let i = 0; i < subReducerSet.length; i++) {
        const subReducer = subReducerSet[i];
        const newState = subReducer(targetedProduct, action);

        if (newState !== targetedProduct) {
            const reducedArray = reduceOneObjectInArray(
                state.familyProducts,
                familyProductIndex,
                newState
            );

            return mixin(
                state, {
                    familyProducts: reducedArray
                }
            );
        }
    }

    return state;
}

/**
 * Product PDP reducer.  Reduces into 'product' in the state
 *
 * @param state The full state object.  This should _ONLY_ be used to determine if Quickshop is open
 * @param productState product subsection of the state
 * @param action action passed
 * @returns reduced product state
 */
export function pdpReducer(state = {}, productState = {}, action) {
    if (isQuickshop(state)) {
        // This product reducer was created for PDP but Quickshop is open
        // Ignore this action and let quickshopReducer run the flow
        return productState;
    }

    if (actionIsForFamilyProduct(action)) {
        return reduceFamilyProductActions(productState, action);
    }

    return reduceProductActions(productState, action);
}
